<template>
  <v-card flat>
    <v-card-title>Produktinformation</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            :items="items"
            item-value="code"
            item-text="_text"
            outlined
            label="Produktinformation"
            item-disabled="hidden"
            v-model="model.productinformation"
            multiple
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click:close="remove(data.item)"
              >
                {{ data.item._text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'DuwaProductinformation',

  props: {
    codes: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    model: {
      productinformation: []
    }
  }),

  created() {
    this.model.productinformation = this.currentProductinformation
  },

  watch: {
    'model.productinformation'(value) {
      this.$store.set(
        'duwa/payload',
        this.payload.map(x => ({
          ...x,
          productinformation: {
            ...x.productinformation,
            after: value.map(code => ({ code }))
          }
        }))
      )
    }
  },

  computed: {
    payload: get('duwa/payload'),
    currentProductinformation: get('duwa/currentProductinformation'),
    items() {
      return this.codes
        .filter(x => x.category === 'productinformation')
        .map(x => {
          if (x.text_43_characters) {
            x._text = x.text_43_characters
          } else if (x.text_13_characters) {
            x._text = x.text_13_characters
          } else if (x.text_9_characters) {
            x._text = x.text_9_characters
          }

          return x
        })
        .filter(
          x =>
            !x.hidden ||
            this.currentProductinformation.some(code => code === x.code)
        )
    }
  },

  methods: {
    remove(item) {
      const index = this.model.productinformation.indexOf(item.code)
      if (index >= 0) this.model.productinformation.splice(index, 1)
    }
  }
}
</script>
